<app-header [title]="title"></app-header>

<div class="col-md-12 col-sm-12 col-sm-12 p-0 box-heightSD" *ngIf="dashboardForm.value as formValue">
  <div class="col-md-12 pt-8">
    <span class="col-md-12 pull-left pl-7">
      <form [formGroup]="dashboardForm">
        <div class="form-group">
          <label class="label-std control-label p-0 b-600 pl-0" for="">Select Type</label>
          <app-common-dropdown-search *ngIf="ClientList.length > 0" [data]="ClientList" [addFieldSetting]="addFieldSetting" (callEvent)="typeChange($event)"></app-common-dropdown-search>
          <!-- <select class="form-control" formControlName="ClientId" (change)="typeChange()">
            <option disabled [value]="null">Select</option>
            <option *ngFor="let Client of ClientList" [value]="Client.Client_Id" [selected]="Client.selected">
              {{Client.Client_Name}}
            </option>
          </select> -->
        </div>
        <div class="form-group">
          <label class=" label-std control-label p-0 b-600 pl-0" for="">Select Type</label>
          <div class="radioBorder">
            <label class="radio-inline">
              <input type="radio" name="dashboardType" value="active" formControlName="dashboardType"
                (change)="typeChange()"> Active </label>
            <label class="radio-inline">
              <input type="radio" name="dashboardType" value="inactive" formControlName="dashboardType"
                (change)="typeChange()"> InActive</label>
            <label class="radio-inline">
              <input type="radio" name="dashboardType" value="all" formControlName="dashboardType"
                (change)="typeChange()"> All</label>
          </div>
        </div>
        <!-- <span>
          <button class="mt-3 btn blue square-btn blue-hover btn-txt mr-10" data-toggle="modal"
            data-target=".account-list" (click)="selectedClient()" [disabled]="disablebtn">Search</button>
        </span> -->
      </form>
    </span>
  </div>
  <div class="col-md-12 supervisor-dash-tbl" *ngIf="formValue.dashboardType!=null && formValue.dashboardType.length>0">
    <ag-grid-angular [enableSorting]="true" [enableColResize]="false" [enableFilter]="true" [pagination]="true"
      [paginationPageSize]="10" class="ag-theme-balham grid-w agGridTable" [rowData]="projectList"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)"
      (cellClicked)="cellClicked($event)">
    </ag-grid-angular>

    <ag-grid-angular [enableSorting]="true" [enableColResize]="false" [enableFilter]="true" [pagination]="true"
      [paginationPageSize]="10" class="ag-theme-balham grid-w agGridTable" [rowData]="projectList"
      [columnDefs]="dollarcolumnDefs" [gridOptions]="dollarDridOptions" (gridReady)="onDollarGridReady($event)"
      (cellClicked)="cellClicked($event)">
    </ag-grid-angular>
  </div>
</div>
<!-- Project De-activate-->
<app-project-deactivate-confirmation [Client_Id]="Client_Id" [projectName]="activeProject" *ngIf="deActivateModal==true"
  (closeModal)="closeDeactivateModal($event)">
</app-project-deactivate-confirmation>

<!-- Project Re-allocation  -->
<app-project-reallocation [Client_Id]="Client_Id" [activeProject]="activeProject" *ngIf="reAllocateModal==true"
  (close)="closeReAllocateModal($event)"></app-project-reallocation>

<app-employee-selector-modal *ngIf="showAddAgentModal==true" [AllEmployees]="Employees" [title]="employeeModalTitle"
  (SendSelectedEmp)="SetSelectedEmp($event)" (CloseModal)="CloseModal($event)"></app-employee-selector-modal>